import { RefreshCw, Mail } from 'lucide-react';

export function ServerErrorScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white shadow-md rounded-2xl p-6 sm:p-8 text-center border border-slate-100">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
          <span className="text-red-500 text-2xl">!</span>
        </div>

        <h1 className="text-xl sm:text-2xl font-semibold text-slate-900 mb-2">
          Something went wrong
        </h1>

        <p className="text-sm sm:text-base text-slate-600 mb-4">
          There was an error while loading this page. It might be a temporary
          issue with the service.
        </p>

        <p className="text-xs sm:text-sm text-slate-500 mb-6">
          Please try refreshing the page. If the problem continues, email us and
          we’ll be happy to help.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center gap-2 rounded-full px-4 py-2 text-sm font-medium bg-slate-900 text-white hover:bg-slate-800 transition"
          >
            <RefreshCw className="h-4 w-4" />
            Refresh page
          </button>

          <a
            href="mailto:support@korucompliance.com?subject=Support%20Request%20-%20Error%20Screen"
            className="inline-flex items-center justify-center gap-2 rounded-full px-4 py-2 text-sm font-medium border border-slate-300 text-slate-700 hover:bg-slate-50 transition"
          >
            <Mail className="h-4 w-4" />
            Email support
          </a>
        </div>

        <p className="mt-4 text-[11px] text-slate-400">
          support@korucompliance.com
        </p>
      </div>
    </div>
  );
}
